module.exports = __webpack_public_path__ + "img/gi.3d52f276.svg";